// frontend/src/components/parent/ChildHeaderCard.tsx

import { ChildSummary } from '../../types/parent.types';
import { IconFlame, IconStar, IconTrophy, IconBook, IconClock } from './ParentIcons';

function initials(fullName: string): string {
  return fullName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
}

const SKILL_LABEL: Record<string, string> = {
  beginner: 'Başlangıç Seviyesi',
  intermediate: 'Orta Seviye',
  advanced: 'İleri Seviye',
};

const SKILL_COLOR: Record<string, string> = {
  beginner: '#10C27A',
  intermediate: '#00AEEF',
  advanced: '#7C3AED',
};

interface ChildHeaderCardProps {
  child: ChildSummary;
  rank?: number | null;
  totalPlayers?: number | null;
  completedCoursesCount?: number;
  inProgressCoursesCount?: number;
  completedLessonsCount?: number;
}

export function ChildHeaderCard({
  child,
  rank,
  totalPlayers,
  completedCoursesCount = 0,
  inProgressCoursesCount = 0,
  completedLessonsCount = 0,
}: ChildHeaderCardProps) {
  const skillColor = SKILL_COLOR[child.skill_level ?? ''] ?? '#64748B';
  const skillLabel = SKILL_LABEL[child.skill_level ?? ''] ?? child.skill_level ?? 'Bilinmiyor';

  return (
    <div className="pcd-header-card">
      {/* Sol — Avatar + bilgi */}
      <div className="pcd-header-left">
        <div className="pcd-avatar">
          <span>{initials(child.full_name)}</span>
          <span className="pcd-avatar-online" title="Online Takip" />
        </div>
        <div className="pcd-header-info">
          <h2 className="pcd-child-name">{child.full_name}</h2>
          <div className="pcd-header-meta">
            {child.age && <span className="pcd-meta-pill">{child.age} yaş</span>}
            <span className="pcd-meta-pill" style={{ borderColor: skillColor, color: skillColor }}>
              {skillLabel}
            </span>
          </div>
        </div>
      </div>

      {/* Sağ — Hızlı istatistikler */}
      <div className="pcd-header-stats">
        <div className="pcd-header-stat">
          <IconFlame size={18} className="pcd-stat-icon pcd-icon-flame" />
          <span className="pcd-header-stat-value">{child.current_streak_days}</span>
          <span className="pcd-header-stat-label">gün seri</span>
        </div>
        <div className="pcd-header-stat">
          <IconStar size={18} className="pcd-stat-icon pcd-icon-star" />
          <span className="pcd-header-stat-value">{child.xp.toLocaleString('tr-TR')}</span>
          <span className="pcd-header-stat-label">XP</span>
        </div>
        {rank != null && (
          <div className="pcd-header-stat">
            <IconTrophy size={18} className="pcd-stat-icon pcd-icon-trophy" />
            <span className="pcd-header-stat-value">#{rank}</span>
            <span className="pcd-header-stat-label">/ {totalPlayers}</span>
          </div>
        )}
        <div className="pcd-header-stat">
          <IconBook size={18} style={{ color: '#10C27A' }} />
          <span className="pcd-header-stat-value">{completedCoursesCount}</span>
          <span className="pcd-header-stat-label">biten kurs</span>
        </div>
        <div className="pcd-header-stat">
          <IconClock size={18} style={{ color: '#00AEEF' }} />
          <span className="pcd-header-stat-value">{inProgressCoursesCount}</span>
          <span className="pcd-header-stat-label">aktif kurs</span>
        </div>
        <div className="pcd-header-stat">
          <IconClock size={18} style={{ color: '#7C3AED' }} />
          <span className="pcd-header-stat-value">{completedLessonsCount}</span>
          <span className="pcd-header-stat-label">biten ders</span>
        </div>
      </div>
    </div>
  );
}
